import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["toggle", "content"]

  reveal() {
    this.contentTarget.hidden = false
    this.toggleTarget.hidden = true
  }
}
